"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBeyonicDescriptionFromEntity = exports.BEYONIC_CURRENCIES = exports.BEYONIC_WEBHOOKS_EVENT_TYPE = exports.INTEGRATION_TYPE = void 0;
/**
 * Optimetriks integration
 */
var INTEGRATION_TYPE;
(function (INTEGRATION_TYPE) {
    INTEGRATION_TYPE["FRESHDESK"] = "FRESHDESK";
    INTEGRATION_TYPE["BEYONIC"] = "BEYONIC";
    INTEGRATION_TYPE["SAP"] = "SAP";
})(INTEGRATION_TYPE || (exports.INTEGRATION_TYPE = INTEGRATION_TYPE = {}));
var BEYONIC_WEBHOOKS_EVENT_TYPE;
(function (BEYONIC_WEBHOOKS_EVENT_TYPE) {
    BEYONIC_WEBHOOKS_EVENT_TYPE["PAYMENT_STATUS_CHANGED"] = "payment.status.changed";
    BEYONIC_WEBHOOKS_EVENT_TYPE["COLLECTION_RECEIVED"] = "collection.received";
    BEYONIC_WEBHOOKS_EVENT_TYPE["CONTACT_CREATED"] = "contact.created";
    BEYONIC_WEBHOOKS_EVENT_TYPE["COLLECT_REQUEST_STATUS_CHANGED"] = "collectionrequest.status.changed";
})(BEYONIC_WEBHOOKS_EVENT_TYPE || (exports.BEYONIC_WEBHOOKS_EVENT_TYPE = BEYONIC_WEBHOOKS_EVENT_TYPE = {}));
var BEYONIC_CURRENCIES;
(function (BEYONIC_CURRENCIES) {
    BEYONIC_CURRENCIES["BXC"] = "Beyonic Test Currency";
    BEYONIC_CURRENCIES["USD"] = "US Dollars";
    BEYONIC_CURRENCIES["EUR"] = "Euro";
    BEYONIC_CURRENCIES["UGX"] = "Uganda Shillings";
    BEYONIC_CURRENCIES["KES"] = "Kenya Shillings";
    BEYONIC_CURRENCIES["GHS"] = "Ghanaian Cedi";
    BEYONIC_CURRENCIES["TZS"] = "Tanzania Shillings";
    BEYONIC_CURRENCIES["RWF"] = "Rwandan Francs";
    BEYONIC_CURRENCIES["ZMW"] = "Zambian Kwacha";
    BEYONIC_CURRENCIES["MWK"] = "Malawian Kwacha";
    BEYONIC_CURRENCIES["BIF"] = "Burundi Franc";
    BEYONIC_CURRENCIES["XOF"] = "West African CFA franc";
    BEYONIC_CURRENCIES["XAF"] = "Central African CFA Franc";
    BEYONIC_CURRENCIES["GNF"] = "The Guinea franc";
})(BEYONIC_CURRENCIES || (exports.BEYONIC_CURRENCIES = BEYONIC_CURRENCIES = {}));
const getBeyonicDescriptionFromEntity = (template, row) => {
    let result = template;
    let regex = /\$[a-z_\d]+\$/g;
    let regexResult;
    let processedExpressions = [];
    do {
        regexResult = regex.exec(template);
        if (regexResult) {
            let [expression] = regexResult;
            if (processedExpressions.includes(expression))
                continue;
            processedExpressions.push(expression);
            let expressionName = expression.split("$").join("");
            let value = evaluate(expressionName);
            result = result.split(expression).join(value);
        }
    } while (regexResult);
    return result;
    function evaluate(expressionName) {
        var _a;
        return (_a = row[expressionName]) !== null && _a !== void 0 ? _a : "null";
    }
};
exports.getBeyonicDescriptionFromEntity = getBeyonicDescriptionFromEntity;
